import * as React from "react";
import { map as _map, isEmpty as _isEmpty } from "lodash";
import ExpandableActivityItem from "./ExpandableActivityItem";


export interface IActivity {
    
    activityTime: string,
    activityType: string,
    activityDetails: string,
    score: number,
    intitalReading?: number,
    peakReading?: number,
    difference?: number,
    timeOverTarget?: number,
    id: string,
    isExpandable?:boolean
}

export interface IActivitiesTableProps {
    title?:string,
    activities: IActivity[],
    isMultiType?:boolean,
    activityTypes?: string[],
    showPagination?:boolean,
}

const MAX_ACTIVITIES_TO_SHOW = 5

const ActivitiesTable = (props: IActivitiesTableProps) => {
    const [activitiesToShow, setActivitiesToShow] = React.useState([])
    const [currentActList, setCurrentActList] = React.useState([])
    const [pageParams, setPageParams] = React.useState({ currPage: 0, maxPageSize: 1, totalItem: 0 })
    const [currentType, setCurrentType] = React.useState<string>("");

    React.useEffect(() => {
        setCurrentList(props.activityTypes?props.activityTypes[0]:"");
        setCurrentType(props.isMultiType?props.activityTypes[0]:"");
    }, [])

    const setCurrentList = (type: string) => {
        const allActivities = props.activities.filter(activity => activity.activityType === type);
        let currPage = 0;
        let maxPage = 1;
        if (allActivities.length > MAX_ACTIVITIES_TO_SHOW) {
            setActivitiesToShow(allActivities.slice(0, MAX_ACTIVITIES_TO_SHOW));
            setCurrentActList(allActivities);
            currPage = 0;
            maxPage = Math.ceil(allActivities.length / MAX_ACTIVITIES_TO_SHOW);
        } else {
            setActivitiesToShow(allActivities)
            setCurrentActList(allActivities);
        }

        setPageParams({
            currPage: currPage,
            maxPageSize: maxPage,
            totalItem: allActivities.length
        });
    }

    const moveForward = () => {
        const moveToPage = pageParams.currPage + 1
        if (moveToPage < pageParams.maxPageSize) {
            const allActivities = [...currentActList]
            const start = MAX_ACTIVITIES_TO_SHOW * moveToPage
            setActivitiesToShow(allActivities.slice(start, start + MAX_ACTIVITIES_TO_SHOW))
            setPageParams({ ...pageParams, currPage: moveToPage })
        }
    }

    const moveBackward = () => {
        const moveToPage = pageParams.currPage - 1
        if (moveToPage >= 0) {
            const allActivities = [...currentActList]
            const start = MAX_ACTIVITIES_TO_SHOW * moveToPage
            setActivitiesToShow(allActivities.slice(start, start + MAX_ACTIVITIES_TO_SHOW))
            setPageParams({ ...pageParams, currPage: moveToPage })
        }
    }

    const capataliseString = (str: string): string => {
        const strArr = str.toLowerCase().split("_");
        strArr.forEach((s: string, i: number) => strArr[i] = strArr[i][0].toUpperCase() + strArr[i].substring(1));
        return strArr.join(" ");
    }

    const toggleAcitivityType = (type: string) => {
        setCurrentType(type);
        setCurrentList(type);
    }

    const addSelectedClass = (type: string) => {
        return currentType === type ? "activities-table-categories__chips activities-table-categories--selected"
            : "activities-table-categories__chips"
    }

    return (
        <div className={"activities-table-container"}>
            { props.title ? <div className="activities-table-header">{props.title}</div> : null }
            {props.isMultiType ? <div className={"activities-table-categories"}>
            {_map(props.activityTypes, (type:string, index:number)=>(
                    <span className={addSelectedClass(type)} onClick={() => toggleAcitivityType(type)}>{capataliseString(type)} ({(props.activities.filter(act=> act.activityType===type)).length})</span>
                ))}
            </div>:null}
            <div className={"activities-table"}>
                {
                    !_isEmpty(activitiesToShow) ? _map(activitiesToShow, (activity: IActivity, index: number) => <ExpandableActivityItem activity={activity} key={activity.id} isExpandable={activity.isExpandable}/>)
                        : <div className="no-activity-image">
                            <img src="/images/no-activity.svg" alt="no-activity" />
                            <p>No {(""+currentType).toLowerCase()} Record</p>
                        </div>
                }
            </div>

            { props.showPagination && activitiesToShow.length >0 ? <div className={"pagination"}>
                <span className={"page-prev"} onClick={moveBackward}>
                    <img src="/images/icons/left-arrow-red.svg" />
                    <span>Previous</span>
                </span>
                <span>{`${pageParams.currPage * MAX_ACTIVITIES_TO_SHOW + 1}-${Math.min(pageParams.currPage * MAX_ACTIVITIES_TO_SHOW + activitiesToShow.length, pageParams.totalItem)} of ${pageParams.totalItem}`}</span>
                <span className={"page-next"} onClick={moveForward} >
                    <span>Next</span>
                    <img src="/images/icons/right-arrow-red.svg" />
                </span>
            </div>:null}

        </div>
    )
}

export default ActivitiesTable